import styled from 'styled-components';
import Button from '../../_shared/components/Button';

export const StyledSubTitle = styled.h1`
  margin-bottom: 20px;
  padding: 0;
  font-size: 24px;
  font-weight: ${({ theme }) => theme.FONT_WEIGHTS.REGULAR} !important;
  line-height: 32px;
`;

export const CheckBox = styled.input.attrs(() => ({
  type: 'checkbox'
}))`
  margin: 0px 8px 0px 0px;
`;

export const OuterBoxContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const OuterBox = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 900px;
  height: 'fit-content';
  background-color: ${({ theme }) => theme.COLORS.BASE};
  justify-content: center;
  z-index: 1;
  top: 220px;
  border-style: solid;
  border-color: ${({ theme }) => theme.COLORS.NEUTRAL_110};
`;

export const ContentWrapper = styled.div`
  width: 92%;
  margin: 36px 30px;
`;

export const SaveButtonWrapper = styled.div`
  margin-bottom: 0px;
`;

export const SaveButton = styled(Button.Primary)`
  min-width: 104px;
  height: 36px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-weight: 700;
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  border-radius: 4px;
  box-shadow: 0px 1px 0px rgba(39, 45, 51, 0.05);
  color: ${({ theme }) => theme.COLORS.BASE};
  text-transform: capitalize;
  letter-spacing: 0;
  margin-bottom: 0px;
`;

export const StyledContent = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: 14px;
  line-height: 21px;
  margin: 0 0 20px 0;
`;

export const StyledSubtitle = styled.div`
  font-size: 14px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-weight: ${({ theme }) => theme.FONT_WEIGHTS.SEMI_BOLD};
  margin: 0 0 20px 0;
`;

export const StyledLabel = styled.div`
  line-height: 22px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-weight: ${({ theme }) => theme.FONT_WEIGHTS.REGULAR};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_95};
  margin: 0 0 30px 0;
  display: inline-flex;
`;
